<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
      id="kt_login"
    >
      <div
        class="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-15"
        :style="{
          backgroundImage: `url(${backgroundImage})`,
          backgroundPosition: 'initial'
        }"
      >
        <div class="d-flex flex-row-fluid flex-column justify-content-between">
          <a href="#" class="flex-column-auto h-25">
            <img src="media/logos/logo-branca1.png" style="width: 40%" />
          </a>

          <div
            class="d-none flex-column-auto d-lg-flex justify-content-between mt-15"
          >
            <div
              class="flex-column-fluid d-flex flex-column justify-content-center"
            >
              <h3 class="font-size-h1 mt-30 mb-5 text-white">
                <!-- Bem vindo(a) -->
              </h3>
              <p class="font-weight-lighter text-white opacity-80">
                Painel de Renovações Zucchetti 
              </p>
              <p class="font-weight-lighter text-white opacity-80">
                © 2023 Zucchetti
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden"
      >
        <div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "auth",
  methods: {},
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    backgroundImage() {
      return "/media/logos/background.png";
      // return process.env.BASE_URL + "media/bg/bg-5.jpg";
    }
  }
};
</script>
